/** Whether an object is a three.js light. */
/**
 * @canonical Whether an object is a three.js light
 */
export function isLight(object) {
    return object.isLight === true;
}
//# sourceMappingURL=isLight.js.map